import { BigNumber } from '@xylabs/sdk-js'
import { useAsyncEffect } from '@xylabs/sdk-react'
import { useState } from 'react'

import { useAuction } from './useAuction'

export const useMinimumBid = () => {
  const [minimumBid, setMinimumBid] = useState<BigNumber>()
  const { auction } = useAuction()
  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (mounted) => {
      if (auction) {
        const minBid = auction.dynamic.minimumBid ?? (await auction.getMinimumBid())
        if (mounted()) {
          setMinimumBid(minBid)
        }
      }
    },
    [auction],
  )
  return minimumBid
}
